import  { useEffect, useRef } from 'react';
import whyImage from '@/assets/VisibilityAssets/marketing.png';

 const WhySection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    const children = section.querySelectorAll(".animate-on-scroll");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fadeUp");
            entry.target.classList.remove("opacity-0");
            observer.unobserve(entry.target); // remove if you want animation only once
          }
        });
      },
      { threshold: 0.2 } // adjust: 0.2 = triggers when 20% visible
    );

    children.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="lg:py-[50px] md:py-[30px] sm:py-[10px] bg-gradient-subtle mt-8">
      <div className="container mx-auto px-2">
        <div className="w-[95%] mx-auto ">
         <div className="grid lg:[grid-template-columns:32%_68%] md:[grid-template-columns:40%_60%] sm:[grid-template-columns:100%] gap-10">
            <div className="flex flex-col justify-center align-center">
             <img src={whyImage} alt="Why Choose Us" className="w-full h-auto object-cover rounded-lg hidden sm:block" />
            </div>
           <div
      ref={sectionRef}
      className="flex flex-col justify-center items-center p-4"
    >
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 text-foreground opacity-0 animate-on-scroll">
        Why You Can't Afford to Ignore This
      </h2>
      <div className="max-w-none text-center">
        <p className="text-muted-foreground leading-relaxed text-[16px] opacity-0 animate-on-scroll [animation-delay:1s]">
          Running ads without a clear plan is like pouring water into a basket; the money goes, but the results don't show.
          Posting randomly on social media might keep your page active, but it won't bring in customers. It only makes your
          business look busy, not profitable. When people hear about your brand, the first thing they do is check you online.
          If they don't find you, or what they see doesn't look credible, they move on to the next option. Every day your
          business goes without a proper marketing system, you're leaving space for competitors to collect the customers
          that should be yours.
        </p>
      </div>
    </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;